import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          minHeight: '60vh', padding: '2rem', textAlign: 'center',
        }}>
          <div style={{
            background: 'var(--bg-secondary, #1a1a2e)', border: '1px solid var(--border-color, #333)',
            borderRadius: '12px', padding: '2.5rem', maxWidth: '480px', width: '100%',
          }}>
            <h2 style={{ color: 'var(--text-primary, #fff)', margin: '0 0 0.75rem', fontSize: '1.25rem' }}>
              Something went wrong
            </h2>
            <p style={{ color: 'var(--text-secondary, #aaa)', margin: '0 0 1.5rem', fontSize: '0.9rem' }}>
              An unexpected error occurred. Please refresh the page and try again.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: 'var(--accent-cyan, #00d4ff)', color: '#000', border: 'none',
                borderRadius: '8px', padding: '0.6rem 1.5rem', cursor: 'pointer',
                fontWeight: 600, fontSize: '0.9rem',
              }}
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
